import { render, staticRenderFns } from "./SelectForm.vue?vue&type=template&id=2980cd82&scoped=true&"
var script = {}
import style0 from "./SelectForm.vue?vue&type=style&index=0&id=2980cd82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2980cd82",
  null
  
)

export default component.exports